import React from "react";
import { Offcanvas, Badge } from "react-bootstrap";
import {
  MdEmail,
  MdDomain,
  MdBusiness,
  MdLanguage,
  MdVerified,
  MdCalendarToday,
  MdDescription,
} from "react-icons/md";

const ScanDetailsOffcanvas = ({ isOpen, onClose, scan }) => {
  if (!scan) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Offcanvas
      show={isOpen}
      onHide={onClose}
      placement="end"
      style={{ width: "500px" }}
    >
      <Offcanvas.Header className="border-bottom">
        <Offcanvas.Title className="d-flex align-items-center">
          <MdDescription className="me-2 text-primary" />
          Scan Details
        </Offcanvas.Title>
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        />
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        {/* User Information Header */}
        <div className="bg-light p-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h6 className="mb-0">
                {`${scan.firstName ? scan.firstName.charAt(0).toUpperCase() + scan.firstName.slice(1).toLowerCase() : ""} ${scan.lastName ? scan.lastName.charAt(0).toUpperCase() + scan.lastName.slice(1).toLowerCase() : ""}`.trim()}
              </h6>
              <small className="text-muted">{scan.email}</small>
            </div>
            <Badge bg={scan.verified ? "success" : "secondary"}>
              {scan.verified ? "Verified" : "Unverified"}
            </Badge>
          </div>
        </div>

        {/* User Details */}
        <div className="p-3 border-bottom">
          <h6 className="text-muted mb-3">User Information</h6>
          <div className="row g-2">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <MdEmail className="text-muted me-2" />
                <span>{scan.email}</span>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex align-items-center">
                <MdDomain className="text-muted me-2" />
                <span>{scan.domain}</span>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex align-items-center">
                <MdLanguage className="text-muted me-2" />
                <span>{scan.language?.toUpperCase()}</span>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex align-items-center">
                <MdVerified className="text-muted me-2" />
                <span>{scan.verified ? "Verified" : "Not Verified"}</span>
              </div>
            </div>
          </div>
        </div>

        {/* OEM Partner Information */}
        <div className="p-3 border-bottom">
          <h6 className="text-muted mb-3">
            <MdBusiness className="me-2" />
            OEM Partner
          </h6>
          {scan.oemPartner ? (
            <div>
              <div className="d-flex align-items-center mb-2">
                {scan.oemPartner.logo && (
                  <img
                    src={scan.oemPartner.logo}
                    alt="Company Logo"
                    className="rounded me-3"
                    style={{ height: "40px", objectFit: "cover", backgroundColor: "lightblue" }}
                  />
                )}
                <div>
                  <div className="fw-bold">{scan.oemPartner.companyName}</div>
                  <small className="text-muted">{scan.oemPartner.email}</small>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-muted">No OEM partner information available</p>
          )}
        </div>

        {/* Domain Report */}
        <div className="p-3 border-bottom">
          <h6 className="text-muted mb-3">Domain Report</h6>
          {scan.domainReport ? (
            <div className="row g-2">
              <div className="col-12">
                <small className="text-muted">Resolved Domain</small>
                <div>{scan.domainReport.resolvedDomain}</div>
              </div>
              <div className="col-6">
                <small className="text-muted">Report Language</small>
                <div>{scan.domainReport.language?.toUpperCase()}</div>
              </div>
              <div className="col-6">
                <small className="text-muted">Report Status</small>
                <div>
                  <Badge
                    bg={scan.domainReport.reportSend ? "success" : "warning"}
                  >
                    {scan.domainReport.reportSend ? "Sent" : "Pending"}
                  </Badge>
                </div>
              </div>
              <div className="col-12">
                <small className="text-muted">Created At</small>
                <div>
                  {isNaN(new Date(scan.domainReport.createdAt))
                    ? "N/A"
                    : formatDate(scan.domainReport.createdAt)}
                </div>
              </div>
            </div>
          ) : (
            <p className="text-muted">No domain report available</p>
          )}
        </div>

        {/* Additional Information */}
        <div className="p-3">
          <h6 className="text-muted mb-3">
            <MdCalendarToday className="me-2" />
            Additional Information
          </h6>
          <div className="row">
            {scan.domainReport && (
              <div className="col-12">
                <small className="text-muted">Report ID</small>
                <div className="font-monospace small">
                  {scan.domainReport._id}
                </div>
              </div>
            )}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ScanDetailsOffcanvas;
